import clsx from "clsx";
import Image from "next/image";

export default function EmptyPlaceholder({ description, className }: { description?: string, className?: string })
{
  return (
    <div className={clsx("flex h-full flex-col items-center justify-center text-gray-400 gap-2", className)}>
      <Image src="/empty_placeholder.webp" alt="empty-placeholder" className="opacity-25 w-32" width={1230} height={711} />
      {description && <span className="text-tiny">{description}</span>}
    </div>
  );
}
